/** Preserves a trailing decimal for incremental input and truncates excess fractional digits. */
export const sanitizeDecimalInput = (raw: string, maximumFractionDigits?: number): string => {
  const [whole, ...fractions] = raw.replace(/[^\d.]/g, '').split('.');
  const fraction = fractions.join('').slice(0, maximumFractionDigits);

  return fractions.length > 0 ? `${whole}.${fraction}` : whole;
};

/**
 * Truncates rather than rounds, so a settled value never exceeds the one typed. Run at commit, not while
 * editing: stripping the separator per keystroke reads `1.5` as `15`.
 */
export const normalizeNumber = (raw: string, maximumFractionDigits = 0): string => {
  const [whole, fraction = ''] = sanitizeDecimalInput(raw, maximumFractionDigits).split('.');

  return fraction === '' ? whole : `${whole}.${fraction}`;
};

/**
 * Tested on the sanitized string rather than the parsed number: `parse*` maps both `''` and `abc` to
 * 0, so a field that holds nothing a digit can be read from would otherwise pass a zero-floor check.
 */
export const isBlank = (raw: string): boolean => sanitizeDecimalInput(raw).replace('.', '') === '';
